// extracted by mini-css-extract-plugin
module.exports = {"messageContent":"MessageBanner_messageContent__ByFl8"};